// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/UserPlatform/AddBusinessInfoDialog/index.css
// module id = 2466
// module chunks = 0